import "./LocalSeoConsultantLuton.module.css";
import Header from "@/reusable_sections/Header";
import Localmarketanalysis from "./sections/Localmarketanalysis";
import Editorial from "./sections/Editorial";
import Methodology from "./sections/Methodology";
import Sectors from "./sections/Sectors";
import LocalServices from "./sections/LocalServices";
import ConsultantBenefits from "./sections/ConsultantBenefits";
import CaseStudy from "./sections/CaseStudy";
import LutonFaq from "./sections/LutonFaq";
import Localseohero from "./sections/Localseohero";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantLutonPage() {
  return <div>
      <Header />
      <Localmarketanalysis />
      <Editorial />
      <Methodology />
      <Sectors />
      <LocalServices />
      <ConsultantBenefits />
      <CaseStudy />
      <LutonFaq />
      <Localseohero />
      <Consultation />
      <Footer />
    </div>;
}